/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgHighlightRows = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path d="M2 3v18h10v-2H4v-6h11v-2H4V5h16v3h2V3H2z" fill="currentcolor" />
      <path
        d="m13.623 17.77.168 2.599L12.805 23h2.527l.961-1.187 2.334-1.154 4.07-8.492L18.942 10l-5.32 7.77zm3.7.981-1.396-.806 3.62-5.287.545.315-2.769 5.778z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgHighlightRows as HighlightRows };
